import { useEffect, useRef } from 'react';
import api from '../helpers/api';

const REFRESH_COOLDOWN_MS = 30_000; // 30 seconds between refreshes

const usePermissionRefresh = () => {
  const lastRefresh = useRef(0);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState !== 'visible') return;

      const now = Date.now();
      if (now - lastRefresh.current < REFRESH_COOLDOWN_MS) return;

      const token = localStorage.getItem('token');
      if (!token) return;

      lastRefresh.current = now;

      api
        .get('user/profile')
        .then((response) => {
          const profileData = response.data?.response;
          if (!profileData) return;

          const stored = localStorage.getItem('authUser');
          if (!stored) return;

          const authUser = JSON.parse(stored);
          const updated = {
            ...authUser,
            roles: profileData.roles ?? authUser.roles,
            permissions: profileData.permissions ?? authUser.permissions,
            role: profileData.role ?? authUser.role,
          };

          localStorage.setItem('authUser', JSON.stringify(updated));
          window.dispatchEvent(new Event('permissions-updated'));
        })
        .catch(() => {
          // Silently ignore — user will get fresh data on next login
        });
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
};

export default usePermissionRefresh;
